import React from "react";
import classes from './Input.module.scss';
import { Input as AntInput } from "antd";

const Input = ({ placeholder, className, ...props }, ref) => {
  return (
    <AntInput
      ref={ref}
      className={`${classes.input} ${className}`}
      placeholder={placeholder}
      {...props}
    />
  )
}

export default Input;
